<!--Form Label left Component - 1.0.0
    Created : 10-SEP-2019
    Created By : SPR/860
    Modified : 10-SEP-2019
    Dependencies: VUE JS
    Use : The v-data-table iterator component is used for displaying tabular data.
          Features include searching, pagination -->
<template>
    <div>
        <v-container v-if="card.type == 'FormLabelLeft'" fluid grid-list-md>
            <v-data-iterator v-if="renderTable"
                             class="form-label-left"
                             :items="formData"
                             :items-per-page.sync="pagination.itemsPerPage"
                             content-tag="v-layout"
                             row
                             wrap>

                <!--Ajax error.-->
                <template v-slot:no-data>
                    <v-flex>
                        <v-card>
                            <div class="form-label-action">
                                <v-icon v-if="permissions.indexOf('A') != -1 && card.type == 'FormLabelLeft'" @click="add" small class="mr-2 vue-marterial-icon vue-marterial-add-icon" title="Add"> add </v-icon>
                            </div>
                            <div class="text-xs-center" style="width: 100%;">No data available</div>
                        </v-card>
                    </v-flex>
                </template>

                <!--Date iterator.-->
                <template v-slot:default="props">
                    <v-flex>
                        <v-card>
                            <div class="form-label-action">
                                <v-icon v-if="permissions.indexOf('A') != -1 && card.type == 'FormLabelLeft'" small class="mr-2 vue-marterial-icon vue-marterial-add-icon" title="Add"> add </v-icon>
                                <v-icon v-if="permissions.indexOf('E') != -1 && card.type == 'FormLabelLeft'" @click="editItem(props.items)" small class="mr-2 vue-marterial-icon vue-marterial-edit-icon" :title="$t('Edit')"> edit </v-icon>
                                <v-icon v-if="permissions.indexOf('D') != -1 && card.type == 'FormLabelLeft'" @click="deleteItem(props.items)" small class="mr-2 vue-marterial-icon vue-marterial-delete-icon" :title="$t('Delete')"> delete </v-icon>
                            </div>
                            <v-list v-for="field in fields" v-if="!field.primaryKey && !field.parent && field.list != false && field.type != 'Hidden'">
                                <v-list-item v-for="(item,i) in props.items">
                                    <v-list-item-content class="title">{{field.title}}</v-list-item-content>
                                    <v-list-item-content class="align-end content">
                                        <v-chip small v-if="field.style && field.style.textValue" :color="_dtChangeColumnUI(item, field.value)" dark>{{item[field.value]}}</v-chip>
                                        <v-chip small v-else-if="field.style && !field.style.textValue" :color="_dtChangeColumnUI(item, field.value)" :title="val" dark></v-chip>
                                        <span v-else> {{ item[field.value] }} </span>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-flex>
                </template>
            </v-data-iterator>
        </v-container>
    </div>
</template>

<script>
    export default {
        /*
            *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
            *  this.$options.parent.fileName - current componets name
        */
        data() {
            return this.$store.state[this.$options.parent.fileName];
        },

        /*
            * Define methods under the `methods` object
            * _dtChangeColumnUI
        */
        methods: {
            /*
                * Trigger custom ui change event
            */
            _dtChangeColumnUI(item, fieldName) {
                let context = this.$store.state[this.$options.parent.fileName];

                //#.changeColumnUI event raising methods
                this.$store.dispatch(context.fileName + '/changeColumnUI', { item, fieldName });

                //#.return color
                return context.columnUI;
            }
        }
    }
</script>
